import React, { Fragment, useEffect, useState } from 'react'
import { tintucService } from '../../services';
import InputImage from '../../components/InputImage';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Select, message } from 'antd';
import { ANH_MAC_DINH } from '../../helpers/constants';

export const ThemMoiLoaiThongTin = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);

    const onClose = () => {
        navigate('/loai-tin-tuc');
    };
    const [lstLoaiTin, setLstLoaiTin] = useState<any[]>([]);
    useEffect(() => {
        tintucService.getAllDanhSachLoaiTinPhanCap().then((response) => {
            if (response.code === 0) {
                setLstLoaiTin(response.data);
            }
        });
        setLoading(false);
    }, []);

    const onSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = await tintucService.themMoiOrChinhSuaLoaiThongTin(null, values.idLoaiCha, values.tieuDe, urlImgAnhDaiDien ? urlImgAnhDaiDien : ANH_MAC_DINH)
            if (response.code === 0) {
                message.success('Tạo mới loại tin tức thành công', onClose)
            } else {
                setLoading(false);
                message.error({ content: response.message, duration: 1 });
            }
        } catch (error: any) {
            setLoading(false);
            message.error({ content: error.message as string, duration: 1 });
        }
    };

    // cho image
    const [urlImgAnhDaiDien, setUrlImgAnhDaiDien] = useState(ANH_MAC_DINH);
    const handleImageChange = (value: string) => {
        setUrlImgAnhDaiDien(value);
    };

    return (
        <Fragment>
            <div className="container-fluid" style={{ paddingTop: '10px' }}>
                {/* Page Heading */}
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0" style={{ color: '#951a1d' }}>THÔNG TIN / Loại Tin Tức / Tạo Mới</h1>
                </div>
                {/* Content Row */}
                <div className='card shadow mb-4'>
                    <div className="card-body" style={{ color: '#000' }}>
                        <Form
                            form={form}
                            name="detail"
                            onFinish={onSubmit}
                            className="c-formNew"
                        >
                            <div className='row mb-2'>
                                <div className='col-12 text-right'>
                                    <div className="form-group">
                                        <Link type="button" className="btn btn-info" to="/loai-tin-tuc">Quay lại</Link>
                                        <button type="submit" className="btn btn-primary ml-2" disabled={loading}> <>
                                            {loading && (
                                                <span className='spinner-border spinner-border-sm mr-1'></span>
                                            )}
                                            Tạo mới
                                        </></button>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Phân loại</label>
                                        <div className="col-sm-8">
                                            <Form.Item name="idLoaiCha">
                                                <Select placeholder="Chọn Loại" size="large">
                                                    <option value=""></option>
                                                    {lstLoaiTin?.map((item: any, index) => (
                                                        <Select.Option key={index} value={item.id}>{item.tenLoai}</Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Tiêu đề</label>
                                        <div className="col-sm-8">
                                            <Form.Item
                                                name="tieuDe"
                                                rules={[{ required: true, message: 'Vui lòng nhập tiêu đề !' }]}>
                                                <Input className='form-control' autoComplete="off" />
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">Hình ảnh đại diện</label>
                                        <div className="col-sm-8">
                                            <Form.Item name="anhDaiDien">
                                                <InputImage onChange={handleImageChange} initialValue={ANH_MAC_DINH} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row mt-2'>
                                <div className='col-12 text-right'>
                                    <div className="form-group">
                                        <Link type="button" className="btn btn-info" to="/loai-tin-tuc">Quay lại</Link>
                                        <button type="submit" className="btn btn-primary ml-2" disabled={loading}> <>
                                            {loading && (
                                                <span className='spinner-border spinner-border-sm mr-1'></span>
                                            )}
                                            Tạo mới
                                        </></button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
